<script>
import macarons from "@/common/theme.json";
import cloneDeep from "lodash/cloneDeep";
import sortBy from "lodash/sortBy";
import moment from "moment";

export default {
  props: {
    visionCheckResult: Array,
    visionCheck: String
  },
  data() {
    const copyResultData = cloneDeep(this.visionCheckResult);
    return {
      copyResultData,
      visionChallengeChart: {}
    };
  },
  mounted() {
    this.$nextTick(function() {
      this.drawLine();
    });
    window.addEventListener("resize", this.resize);
  },

  destroyed() {
    window.removeEventListener("resize", this.resize);
  },
  methods: {
    drawLine() {
      //   let reverseData = sortBy(this.copyResultData, "createdAt");
      const checkResult = [["value", "能力"]];
      const colorList = [];
      this.copyResultData.forEach(item => {
        checkResult.push([item.score, item.name]);
        colorList.push(item.color);
      });
      //   console.log(">>>>>", colorList);
      this.$echarts.registerTheme("myMacarons", macarons);
      const chartComponent = this.$refs[this.visionCheck];
      let myChart = this.$echarts.init(chartComponent, "myMacarons");

      myChart.setOption({
        dataset: {
          source: checkResult
        },
        grid: {
          containLabel: true
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow"
          }
        },
        xAxis: {
          max: 100,
          min: 0
        },
        yAxis: {
          type: "category"
        },
        series: [
          {
            type: "bar",
            encode: {
              // Map the "amount" column to X axis.
              x: "value",
              // Map the "product" column to Y axis
              y: "能力"
            },
            itemStyle: {
              normal: {
                //好，这里就是重头戏了，定义一个list，然后根据所以取得不同的值，这样就实现了，
                color: function(params) {
                  // build a color map as your need.
                  return colorList[params.dataIndex];
                } //以下为是否显示，显示位置和显示格式的设置了
              }
            }
          }
        ]
      });
      this.visionChallengeChart = myChart;
    },
    resize: function() {
      this.visionChallengeChart.resize();
    }
  }
};
</script>
<template>
  <div :ref="visionCheck" :style="{'width': '500px', height: '450px'}"></div>
</template>



// WEBPACK FOOTER //
// src/components/patientManagement/visionCheckCharts.vue